import { type PropsWithChildren } from 'react';

import { XAxis } from '../../core/components/sparkline-display/slots/XAxis.js';
import { YAxis } from '../../core/components/sparkline-display/slots/YAxis.js';
import type { SparklineProps } from '../../core/components/sparkline-display/types/sparkline-props.js';

/**
 * Slot props for the sparkline component within SingleValueGrid.
 * @public
 */
export interface SingleValueGridSparklineProps
  extends Omit<
    SparklineProps,
    | 'data'
    | 'loading'
    | 'labelsAlignment'
    | 'labelsFixedWidth'
    | 'width'
    | 'height'
  > {
  /** Accessor function or string to retrieve the data for the sparkline. */
  dataAccessor?: string;
  /** Accessor function to retrieve the color of the sparkline. */
  colorAccessor?: string;
}

const SparklineRoot = (
  props: PropsWithChildren<SingleValueGridSparklineProps>,
) => null;

/**
 * @public
 */
export const Sparkline = Object.assign(SparklineRoot, {
  XAxis,
  YAxis,
});

(Sparkline as typeof Sparkline & { displayName: string }).displayName =
  'SingleValueGrid.Sparkline';
